import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-af725fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "stats-component" }
const _hoisted_2 = {
  class: "",
  id: "counters"
}
const _hoisted_3 = { class: "counter flex-col-reverse md:flex-row flex md:justify-between mb-24 md:mb-32" }
const _hoisted_4 = { class: "w-full md:w-1/2 text-left" }
const _hoisted_5 = { class: "counter-label title-label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "collective", -1))
const _hoisted_7 = { class: "counter-info pr-16" }
const _hoisted_8 = { class: "w-full md:w-1/2 text-right counter-value pt-12" }
const _hoisted_9 = { id: "charts" }
const _hoisted_10 = {
  key: 0,
  class: "w-full md:w-1/2 text-left"
}
const _hoisted_11 = { class: "chart-label title-label" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "w-full md:w-1/2 chart-value mb-12" }
const _hoisted_14 = {
  key: 1,
  class: "w-full md:w-1/2 text-left"
}
const _hoisted_15 = { class: "chart-label title-label" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  class: "",
  id: "counters-small"
}
const _hoisted_18 = { class: "counter block md:flex md:justify-between mb-24 md:mb-32" }
const _hoisted_19 = { class: "w-full md:w-2/5 counter-value" }
const _hoisted_20 = { class: "w-full md:w-3/5 text-left" }
const _hoisted_21 = { class: "counter-label title-label" }
const _hoisted_22 = { class: "counter-info" }

import { ref } from 'vue';
import { DoughnutChart } from 'vue-chart-3';
import useAirtable from "@/composables/useAirtable";

interface IDisplayElement {
  key: string
  label: string
  info: string
}



export default /*#__PURE__*/_defineComponent({
  __name: 'NumbersComponent',
  async setup(__props) {

let __temp: any, __restore: any

const { records, fetchRecords, aggregateCounts, sumCounts } = useAirtable();
const chartDataEra = ref({})
const chartDataGender = ref({})
const chartDataRace = ref({})
const dataColors = [
  '#825af9',
  '#35d9c3',
  '#4375ff',
  '#6d3dbf',
  '#2cb1a1',
  '#3658d4'
]

const chartOptions = ref({
  responsive: true,
  elements: {
    arc: {
      borderWidth: 0
    }
  },
  plugins: {
    legend: {
      display: false
    },
    title: {
      display: false,
    },
  },
});

const prepareChartData = (key: any) => {
  return {
    labels: Object.keys(aggregateCounts[key]),
    datasets: [{
      data: Object.values(aggregateCounts[key]),
      backgroundColor: dataColors
    }]
  };
};

const renderAggregateCounts = (key: string): string => {
  const entries = Object.entries(aggregateCounts[key]);
  return entries.map(([label, count], index) => {
    const color = dataColors[index % dataColors.length];
    return `<span class="font-bold" style="color: ${color};">${count} ${label}s</span>`;
  }).join(', ');
}

// This will return a string with each count and label wrapped in a span with the corresponding color.
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchRecords())),
  await __temp,
  __restore()
)
chartDataEra.value = prepareChartData('Era')
chartDataGender.value = prepareChartData('Gender')
chartDataRace.value = prepareChartData('Race')


const chartElements: Array<IDisplayElement> = [
  {key: 'race', label: 'Racial Composition', info: `The racial composition of political prisoners - ${renderAggregateCounts('Race')} - speaks volumes about the intersection of race and political dissent in the United States.<br/><br/>
  These statistics compel us to question how race influences both the likelihood of becoming a political prisoner and the experiences of these individuals within the justice system.`},

  {key: 'gender', label: 'Gender Disparity', info: `In examining the stark disparity between genders - ${renderAggregateCounts('Gender')} - the data reflects a broader societal narrative.<br/><br/>
  It's essential to delve deeper into these numbers to understand the underlying causes of such a vast gender gap in political imprisonment, considering factors like historical marginalization, societal expectations, and the different risks and challenges faced by each gender in their pursuit of justice and equality.`}
]

const sumElementsSmallNumbers: Array<IDisplayElement> = [
  {
    key: 'individualsInExile',
    label: 'Individuals in Exile',
    info: 'The count of individuals in exile underscores the harsh realities faced by those who challenge systemic powers. Their exile is a stark reminder of the sacrifices made in the pursuit of social and political change.'
  },
  {
    key: 'individualsImprisoned',
    label: 'Individuals Imprisoned',
    info: 'This figure represents a broader narrative of political resistance, encompassing those who face incarceration and exile. Their stories are emblematic of a larger struggle for justice and the ongoing fight against systemic oppression.'
  }
    ]

const sumElements: Array<IDisplayElement> = [
  {
    key: 'accumulatedDaysImprisoned',
    label: 'Days Imprisoned',
    info: 'This number reflects the staggering amount of time individuals, often activists and dissidents, have been confined. It symbolizes the enduring struggle against systemic injustice and the long shadow cast by policies that disproportionately target marginalized communities.'
  },
  {
    key: 'accumulatedDaysInExile',
    label: 'Days in Exile',
    info: 'Exile, a forced separation from one\'s homeland, often results from standing against oppressive regimes. This figure represents not just days lost, but lives uprooted and voices silenced in the fight for justice and human rights.'
  }
]


return (_ctx: any,_cache: any) => {
  const _component_vue3_autocounter = _resolveComponent("vue3-autocounter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sumElements, (element) => {
        return _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(element.label), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(element.info), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_vue3_autocounter, {
              ref_for: true,
              ref: "counter",
              startAmount: 0,
              endAmount: _unref(sumCounts)[element.key],
              duration: 5,
              separator: ",",
              decimals: 0,
              autoinit: true
            }, null, 8, ["endAmount"])
          ])
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chartElements, (element, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "chart mb-24 md:mb-32 flex-col-reverse md:flex-row flex md:justify-between"
        }, [
          (index % 2 === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(element.label), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    innerHTML: element.info
                  }, null, 8, _hoisted_12)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(DoughnutChart), {
              options: chartOptions.value,
              chartData: element.key === 'gender' ? chartDataGender.value : chartDataRace.value
            }, null, 8, ["options", "chartData"])
          ]),
          (index % 2 !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(element.label), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    innerHTML: element.info
                  }, null, 8, _hoisted_16)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sumElementsSmallNumbers, (element) => {
        return _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_vue3_autocounter, {
              ref_for: true,
              ref: "counter",
              startAmount: 0,
              endAmount: _unref(sumCounts)[element.key],
              duration: 5,
              separator: "",
              decimals: 0,
              autoinit: true
            }, null, 8, ["endAmount"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(element.label), 1),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString(element.info), 1)
            ])
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})